import './init';
import './index.scss';
import './styles/allStyles.scss';

import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router';
import * as Sentry from '@sentry/react';

import { ThemeWrapper } from '@zendesk/forethought-elements';
import InitApp from './components/authentication-wall/initApp';
import ChunkErrorBoundary from './components/chunk-error-boundary/ChunkErrorBoundary';
import { initSentry } from './utils/sentryUtils';
import UnsecuredPage from 'src/components/unsecured-page';
import i18n from 'src/locales';
import store from 'src/store/store';
import { basePath } from 'src/utils/basePath';

initSentry();

const container = document.getElementById('root');

const renderApp = () => {
  if (!container) {
    return;
  }
  if (window.self === window.top) {
    // prevents click jacking
    const root = createRoot(container);
    root.render(
      <Sentry.ErrorBoundary>
        <ChunkErrorBoundary>
          <Provider store={store}>
            <I18nextProvider i18n={i18n}>
              <ThemeWrapper themeVersion='July2025'>
                {/* Disable startTransition to fix slow navigation with RTK Query/Redux
                    See: https://github.com/remix-run/react-router/discussions/12855 */}
                <Router basename={basePath} unstable_useTransitions={false}>
                  <InitApp />
                </Router>
              </ThemeWrapper>
            </I18nextProvider>
          </Provider>
        </ChunkErrorBoundary>
      </Sentry.ErrorBoundary>,
    );
  } else {
    const root = createRoot(container);
    root.render(<UnsecuredPage />);
  }
};

renderApp();
